import React, {useMemo} from "react";
import Map, {Source, Layer, FullscreenControl, NavigationControl, Popup, AttributionControl} from 'react-map-gl';
import MapLegend from "./MapLegend";
import {ReactComponent as Logo} from "../images/ispace_plus_logo_cleaned.svg";

const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

const logoStyle = {
    position: "absolute",
    marginLeft: "10px",
    bottom: 0,
    left:0,
    zIndex: 99,
    width: "100px",
}

const MyMap = ({mapState, setMapState, visibleLayer, features, selectFeature, resultFeatures, setupPopup, popupInfo, valueBreaks}) => {
    const gemeindenStyle = {
        id : "Einheiten-all",
        type: "fill",
        paint: {
            "fill-color": "rgba(125,179,171,0.6)",
            "fill-outline-color":"#ffffff"
        }
    }
    const rasterStyle1000 = {
        id : "Raster-1000",
        type: "fill",
        paint: {
            "fill-color": "rgba(159,184,136,0.7)",
            "fill-outline-color":"#ffffff"
        }
    }
    const featureIdArr = features.length>0? features.map(e => e.properties["spec_id"]): "";

    const rasterStyle500 = {
        id : "Raster-500",
        type: "fill",
        paint: {
            "fill-color": "rgba(214,163,148,0.4)",
            "fill-outline-color":"#ffffff"
        }
    }
    const selectedStyle={
        id : "Selected",
        type: "line",
        paint: {
            "line-color": "rgba(0,255,234,0.69)",
            "line-width":5
        }
    }

    let styleStepsArr = (valueBreaks.slice(1, -1)).map((value) => value + 1);

    // generate style for the query result layer
    const queryResultStyle = (stepsArr) => {
        let stepNum = stepsArr.length;
        const colorArr = ['#F2F12D', '#D5AE29', '#B86B25', '#954E23', '#723122']

        const style = {
            id : "Result",
            type: "fill",
            paint: {
                "fill-color": colorArr[0],
                'fill-opacity': 0.55,
                "fill-outline-color":"rgb(143,104,74)",
            }
        }

        if (stepNum > 0) {
            style.paint["fill-color"] = ['step', ['get', 'commuter_value']];
            for (let i = 0; i < stepNum ; i++) {
            // define classes and colors for the fill-color
                style.paint["fill-color"].push(colorArr[i], stepsArr[i]);
            }
            style.paint["fill-color"].push(colorArr[stepNum]);
        }
        return style;
    }

    const queryResultLabelStyle={
        id: "Result-label",
        type: "symbol",
        layout: {
            "text-field": ["get", "commuter_value"],
            "text-size": 13,
        },
        paint: {
            "text-color": "#000000",
            "text-halo-color": "#ffffff",
            "text-halo-width": 2,

        }
    }

    const filterGemeinden = useMemo(() => ['==', 'type_name', 'Gemeinden'], []);
    const filter1000 = useMemo(() => ['==', 'type_name', '1.000m Rasterzellen'], []);
    const filter500 = useMemo(() => ['==', 'type_name', '  500m Rasterzellen'], []);
    const filterSelected = useMemo(() => ['in', 'spec_id', ...featureIdArr], [featureIdArr]);

    const setVisibleLayer = (layerId, visibleLayer) =>{
        if (layerId === visibleLayer ){
            return {
                visibility: "visible"
            }
        } else {
            return {
                visibility: "none"
            }
        }
    }

    return (
        <Map
            initialViewState={mapState}
            style={{width: "100vw", height: "100vh"}}
            mapStyle="mapbox://styles/mapbox/light-v11"
            mapboxAccessToken={MAPBOX_TOKEN}
            attributionControl={false}
            logoPosition="bottom-right"
            onMove={evt => setMapState(evt.viewState)}
            onClick={selectFeature}
            interactiveLayerIds={[visibleLayer]}
            onMouseMove={visibleLayer==="4"? setupPopup: () => null}
        >
            <Source id="basemapAt" type="raster" tiles={["https://mapsneu.wien.gv.at/basemap/bmapgrau/normal/google3857/{z}/{y}/{x}.png"]} tileSize={256}>
                <Layer type="raster"></Layer>
            </Source>
            <Source id="QueryResult" type="geojson" data={resultFeatures}>
                 <Layer {...queryResultStyle(styleStepsArr)} layout={setVisibleLayer("4", visibleLayer)} id="4" />
                 <Layer {...queryResultLabelStyle} id="queryResultLayerLabel"/>
            </Source>
            <Source id="Einheiten" type="geojson" data="./data/einheiten-4326-2021.geojson">
                <Layer {...gemeindenStyle} filter={filterGemeinden} layout={setVisibleLayer("1", visibleLayer)} id="1" />
                <Layer {...rasterStyle1000} filter={filter1000} layout={setVisibleLayer("2", visibleLayer)} id="2"/>
                <Layer {...rasterStyle500} filter={filter500} layout={setVisibleLayer("3", visibleLayer)} id="3"/>
                <Layer {...selectedStyle} filter={filterSelected} id="selectedLayer" />
            </Source>
            {visibleLayer==="4" && JSON.stringify(popupInfo.coordinates) !== "{}" &&
                 <Popup
                     longitude={popupInfo.coordinates.lng}
                     latitude={popupInfo.coordinates.lat}
                     anchor="bottom"
                     closeButton={false}
                     closeOnClick={false}
                 >
                     {popupInfo.featureName}
                 </Popup>}
            <FullscreenControl />
            <NavigationControl />
            <AttributionControl customAttribution="Basemap.at"/>
            {   // legend only shows when the first natural break is positive (not the initial state)
                valueBreaks[0] > 0 &&
               <MapLegend valueBreaksArr={valueBreaks} ></MapLegend>
            }
            <Logo alt="logo-ispace" style={logoStyle}></Logo>
        </Map>
    )
}

export default MyMap;
